import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { withTheme } from "styled-components";
import DatePicker from "react-datepicker";
import NumberSelect from "../../atomic/NumberSelect/NumberSelect";
import CheckboxGroup from "react-checkbox-group";
import "react-datepicker/dist/react-datepicker.css";
import { RadioGroup, RadioButton } from "react-radio-buttons";
import { Route, Switch, useParams, Redirect } from "react-router-dom";
import Button from "../../atomic/Button/Button";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { addScheduleAction, isSaving } from "../../../state/data";

const Root = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  label {
    margin: 20px 0px 10px 0px;
  }
`;

const Buttons = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: flex-end;
`;

export function generateId() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
    var r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

const week = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
export default withTheme(({ theme }) => {
  const [number, setNumber] = useState(5);
  const [duration, setDuration] = useState(60);
  const [repeat, setRepeat] = useState(false);
  const [date, setDate] = useState(new Date());
  const [days, setDays] = useState([]);
  const [endType, setEndType] = useState("date");
  const [endRepeat, setEndRepeat] = useState(1);
  const [endDate, setEndDate] = useState(
    new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 3)
  );
  const { locationId, lessonId, scheduleId } = useParams();
  const dispatch = useDispatch();
  const saving = useSelector(isSaving);
  const [redir, setRedir] = useState(false);

  useEffect(() => {
    if (saving) {
      setRedir(true);
    }
  }, [saving]);

  if (!saving && redir) {
    return <Redirect to={"/schedule/show/" + locationId + "/" + lessonId} />;
  }

  const makeSchedule = () => {
    const schs = [];
    schs.push({
      id: scheduleId,
      locationId,
      lessonId,
      date: date.getTime(),
      duration,
      number
    });
    if (repeat) {
      const indexDays = days.map(d => {
        let w = -1;
        week.forEach((ww, ind) => {
          if (ww === d) {
            w = ind;
          }
        });
        return w;
      });
      const start = date.getTime();
      let rep = 1;
      for (let i = 1; i < 365; i++) {
        const next = start + i * 1000 * 60 * 60 * 24;
        const dayOfWeek = new Date(next).getDay();
        const okDay = !!indexDays.filter(f => dayOfWeek === f)[0];
        if (okDay) {
          if (endType === "date") {
            if (endDate.getTime() > next) {
              schs.push({
                id: generateId(),
                locationId,
                lessonId,
                date: next,
                duration,
                number
              });
            } else {
              break;
            }
          } else {
            if (rep < endRepeat) {
              schs.push({
                id: generateId(),
                locationId,
                lessonId,
                date: next,
                duration,
                number
              });
              rep = rep + 1;
            } else {
              break;
            }
          }
        }
      }
    }
    return schs;
  };

  return (
    <Root>
      <h1>Create Schedule</h1>
      <DatePicker
        selected={date}
        onChange={date => setDate(date)}
        inline
        showTimeSelect
        minTime={new Date("December 1, 2019 06:00 am")}
        maxTime={new Date("December 1, 2019 11:00 pm")}
      />
      <label>Duration (in min)</label>
      <NumberSelect number={duration} setNumber={setDuration} />
      <label>Available spaces</label>
      <NumberSelect number={number} setNumber={setNumber} />
      <CheckboxGroup
        name="repeat"
        value={repeat ? ["repeat"] : []}
        onChange={v => setRepeat(v.length > 0)}
      >
        {Checkbox => (
          <>
            <label>
              <Checkbox value="repeat" /> Repeat
            </label>
          </>
        )}
      </CheckboxGroup>
      {repeat && (
        <>
          <label>Days of week</label>
          <div style={{ display: "flex" }}>
            <CheckboxGroup
              name="days"
              value={days || []}
              onChange={v => setDays(v)}
            >
              {Checkbox => (
                <>
                  {week.map(w => (
                    <label key={w}>
                      <Checkbox value={w} /> {w}
                    </label>
                  ))}
                </>
              )}
            </CheckboxGroup>
          </div>
          <label>Stop schedule</label>
          <div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                padding: "0px 0px 10px 0px"
              }}
            >
              <input
                style={{ marginRight: "10px" }}
                type="radio"
                value="date"
                checked={endType === "date"}
                onChange={e => {
                  if (e.target.checked) {
                    setEndType("date");
                  }
                }}
              />
              Date{" "}
              <div style={{ padding: "0px 10px" }}>
                <DatePicker
                  selected={endDate}
                  onChange={date => setEndDate(date)}
                />
              </div>
            </div>
            <div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start"
                }}
              >
                <input
                  style={{ marginRight: "10px" }}
                  type="radio"
                  value="repeat"
                  onChange={e => {
                    if (e.target.checked) {
                      setEndType("repeat");
                    }
                  }}
                  checked={endType === "repeat"}
                />
                After{" "}
                <div style={{ padding: "0px 10px" }}>
                  <NumberSelect
                    number={endRepeat}
                    setNumber={setEndRepeat}
                  ></NumberSelect>
                </div>
                repetitions
              </div>
            </div>
          </div>
        </>
      )}
      <Buttons>
        <Link to={"/schedule/show/" + locationId + "/" + lessonId}>
          <Button>Cancel</Button>
        </Link>
        {!saving && (
          <Button
            inverted
            onClick={() => dispatch(addScheduleAction(makeSchedule()))}
          >
            Create
          </Button>
        )}
        {saving && (
          <Button inverted>
            <FontAwesomeIcon
              icon={["fas", "spinner"]}
              size="1x"
              color={theme.color5}
              spin
            />
          </Button>
        )}
      </Buttons>
    </Root>
  );
});
